module.exports = __webpack_public_path__ + "img/zzc.10d45c05.png";